import { computed, toJS } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IServiceContacts } from '../../actions/contacts/get-service-contacts.action';
import { Label } from '../../components/label';
import { ILxsContactPageData } from './lxs-contact-page.data';
import { ILxsContactPageProps } from './lxs-contact-page.props.autogenerated';

export interface ILxsContactPageViewProps extends ILxsContactPageProps<ILxsContactPageData> {
    serviceContacts: IServiceContacts[];
}

@observer
class LxsContactPage extends React.PureComponent<ILxsContactPageProps<ILxsContactPageData>> {
    @computed
    get serviceContacts(): IServiceContacts[] {
        const raw = toJS(this.props.data?.getServiceContacts?.result);
        if (!raw) {
            return [];
        }
        return raw.value;
    }

    public render(): JSX.Element | null {
        const serviceContacts = this.serviceContacts;
        const { resources } = this.props;

        const isLoading = !this.props.data?.getServiceContacts?.result;

        if (isLoading) {
            return <Label className='lxs-contact-page__loading' label={resources.loadingLabel} />;
        }

        return this.props.renderView({ ...(this.props as ILxsContactPageProps<ILxsContactPageData>), serviceContacts });
    }
}

export default LxsContactPage;
